import UserProfileSkeleton from '@/components/skeletons/UserProfileSkeleton';
import UserProfile from '@/components/UserProfile';
import type { ProfileSummary } from '@/types/profile';
import { useUserProfile } from '@/context/UserProfileContext';

import { api } from '@/utils/api';
import { IonPage } from '@ionic/react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

export default function UserPage() {
  const { username } = useParams<{ username: string }>();
  const { t } = useTranslation();
  const { profile } = useUserProfile(); // Get current user profile from context
  const [profileDetailed, setProfileDetailed] = useState<ProfileSummary | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchProfile = async () => {
      setLoading(true);
      setError(null);

      try {
        // // Check if this is the current user's profile
        // if (profile && profile.username === username) {
        //   console.log('Using current user profile from context');
        //   setProfileDetailed({
        //     ...profile,
        //     membershipCourse: null,
        //     trips: {},
        //     totalTrips: 0,
        //     friendsCount: 0,
        //     verified: false,
        //     posts: [],
        //     stats: { countriesVisited: [] }
        //   });
        //   setLoading(false);
        //   return;
        // }

        // Otherwise fetch the profile details from API
        const { data } = await api.get(`/profile/${username}/details`);
        setProfileDetailed(data as ProfileSummary);
      } catch (err: any) {
        console.error('Error fetching profile:', err);

        if (err.response?.status === 404) {
          setError('profileNotFound');
        } else {
          console.error('Error fetching profile details:', err);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [username, profile]);



  return (
    <IonPage>
      {loading ? (
        <UserProfileSkeleton />
      ) : profileDetailed ? (
        <UserProfile
          data={profileDetailed}
          edit={false}
          profileDetailed={profileDetailed}
        />
      ) : error === 'profileNotFound' ? (
        <div className="flex flex-col items-center justify-center h-full p-4 text-center">
          <h2 className="text-xl font-medium mb-2">{t('profile_not_found')}</h2>
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center h-full p-4 text-center">
          <UserProfileSkeleton />
        </div>
      )}
    </IonPage>
  );
}